import { Text, Image, Flex } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

import { DescriptionText } from "./description-text";
import { MESSAGES } from "./message-definitions";
import StepOne from "./step-one.svg";
import StepTwo from "./step-two.svg";
import StepThree from "./step-three.svg";
import descriptionCardsStyles from "./description-cards.module.css";

export const DescriptionCards = () => {
  const { formatMessage } = useIntl();

  const {
    descriptionCardsHeading,
    descriptionCardsFirstCardSubheading,
    descriptionCardsFirstCardHeading,
    descriptionCardsFirstCardBody,
    descriptionCardsSecondCardSubheading,
    descriptionCardsSecondCardHeading,
    descriptionCardsSecondCardBody,
    descriptionCardsThirdCardSubheading,
    descriptionCardsThirdCardHeading,
    descriptionCardsThirdCardBody,
  } = MESSAGES;

  const descriptionCards = [
    {
      id: "step-1",
      StepDescription: StepOne,
      texts: {
        step: formatMessage(descriptionCardsFirstCardSubheading),
        heading: formatMessage(descriptionCardsFirstCardHeading),
        content: formatMessage(descriptionCardsFirstCardBody),
      },
    },
    {
      id: "step-2",
      StepDescription: StepTwo,
      texts: {
        step: formatMessage(descriptionCardsSecondCardSubheading),
        heading: formatMessage(descriptionCardsSecondCardHeading),
        content: formatMessage(descriptionCardsSecondCardBody),
      },
    },
    {
      id: "step-3",
      StepDescription: StepThree,
      texts: {
        step: formatMessage(descriptionCardsThirdCardSubheading),
        heading: formatMessage(descriptionCardsThirdCardHeading),
        content: formatMessage(descriptionCardsThirdCardBody),
      },
    },
  ];

  return (
    <Flex direction="column" gap="3">
      <Text size="base" fontWeight="regular" fontStyle="regular">
        {formatMessage(descriptionCardsHeading)}
      </Text>
      <Flex direction="row" gap="6">
        <div className={descriptionCardsStyles.swipeContainer}>
          {descriptionCards.map(({ id, StepDescription, texts }) => (
            <div key={id} className={descriptionCardsStyles.swipeCard}>
              <Image src={StepDescription} alt="StepDescription" />
              <DescriptionText heading={texts.heading} step={texts.step} content={texts.content} />
            </div>
          ))}
        </div>
      </Flex>
    </Flex>
  );
};
